import React, { useEffect, useState } from 'react';

// Helper function to calculate time difference
const calcTime = (milliseconds) => {
  const secondsTotal = Math.floor(milliseconds / 1000);
  const days = Math.floor(secondsTotal / 86400);
  const hours = Math.floor((secondsTotal % 86400) / 3600);
  const minutes = Math.floor((secondsTotal % 3600) / 60);
  const seconds = secondsTotal % 60;
  return [days, hours, minutes, seconds];
};

const Countdown = ({ endDateStr }) => {
  const [timeLeft, setTimeLeft] = useState([0, 0, 0, 0]);
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    // Parse the end date string
    const regexMatch = endDateStr.match(
      /([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4}) ([0-9]{2}):([0-9]{2}):([0-9]{2})/
    );
    if (!regexMatch) return;

    const end = new Date(
      regexMatch[3],
      regexMatch[2] - 1,
      regexMatch[1],
      regexMatch[4],
      regexMatch[5],
      regexMatch[6]
    );

    const updateTime = () => {
      const today = new Date();
      if (today.getTime() <= end.getTime()) {
        const diff = end.getTime() - today.getTime();
        setTimeLeft(calcTime(diff));
      } else {
        setExpired(true);
      }
    };

    updateTime(); // Initialize the timer
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval); // Cleanup on component unmount
  }, [endDateStr]);

  if (expired) {
    return <p className="end">Sorry, your session has expired.</p>;
  }

  return (
    <div className="countdown">
      <div className="countDown">
        <div className="container">
          <div className="c-inner">
            <div className="a">
              <div>{String(timeLeft[0]).padStart(2, '0')}</div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="c-inner">
            <div className="a">
              <div>{String(timeLeft[1]).padStart(2, '0')}</div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="c-inner">
            <div className="a">
              <div>{String(timeLeft[2]).padStart(2, '0')}</div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="c-inner">
            <div className="a">
              <div>{String(timeLeft[3]).padStart(2, '0')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Timer = () => {
  const endDateStr = '10/03/2025 10:20:00'; // Your target end date
  return (
      <Countdown endDateStr={endDateStr} />
  );
};

export default Timer;
